import React, { useState } from 'react';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CancelIcon from '@material-ui/icons/Cancel';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import Badge from '@material-ui/core/Badge';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import { getUnsuccessfulSyncPatientById } from '../../../actions/areas/planner/queryActions';

import { parseShortDateTime, parseShortDateWithTime } from '../../../utils/dates';

export default function AuditDetails({ modelDetails, auth, onClose }) {
  const [state, setState] = useState({
    model: null,
    isLoading: true,
  });

  const callback = response => {
    if (response !== null) setState({ ...state, model: response.auditDetails });
  };

  if (state.model === null) getUnsuccessfulSyncPatientById(auth, modelDetails.id, false, callback);

  const isExcludePropValue = value => value !== '@|@';

  const headerRender = () => {
    return (
      <div className="sidePanel-header card-status-green">
        <div className="sidePanel-header-subtitle">
          <Box display="flex">
            <Box flexGrow={1} py={1}>
              <Typography variant="subtitle1">Audit Details</Typography>
            </Box>
            <Box>
              <IconButton onClick={() => onClose()}>
                <CancelIcon />
              </IconButton>
            </Box>
          </Box>
        </div>
        <div className="sidePanel-header-wrapper">
          <div className="sidePanel-header-left-info-wrap">
            <div className="sidePanel-header-title">
              <Typography variant="h2" gutterBottom>
                {state.model.errorMessage}
              </Typography>
            </div>
            <div className="sidePanel-header-info patient-header">
              <Box className="assignment-desc-info" display="flex" flexDirection="row">
                <Box display="flex" flexDirection="row">
                  <Box className="header-icon-wrapper">
                    <Badge className="clinician-badge" color="error">
                      <span className="icon-extend icon-medic" />
                      <span className="info-text">{state.model.createdBy}</span>
                    </Badge>
                  </Box>
                  <Box className="header-icon-wrapper">
                    <AccessTimeIcon />
                    <span className="info-text"> {parseShortDateWithTime(state.model.dateCreated)}</span>
                  </Box>
                </Box>
              </Box>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const otherPatientDetailsRender = () => {
    return (
      <div className="clinician-info-box">
        <Typography variant="h6" gutterBottom>
          Other Details
        </Typography>
        <List className="list-underline">
          <ListItem>
            <ListItemText primary="Title" />
            <span className="divider" />
            <ListItemText secondary={state.model.patient.title || '-'} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Gender" />
            <span className="divider" />
            <ListItemText secondary={state.model.patient.gender || '-'} />
          </ListItem>
          <ListItem>
            <ListItemText primary="NHS No" />
            <span className="divider" />
            <ListItemText secondary={state.model.patient.nhsNumber || '-'} />
          </ListItem>
          <ListItem>
            <ListItemText primary="First and Last Name" />
            <span className="divider" />
            <ListItemText secondary={state.model.patient.patientFullName || '-'} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Date of birth" />
            <span className="divider" />
            <ListItemText secondary={parseShortDateTime(state.model.patient.dateOfBirth)} />
          </ListItem>
          <ListItem>
            <ListItemText primary="GP Practice Name" />
            <span className="divider" />
            <ListItemText secondary={state.model.patient.gpPractice} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Pas Number" />
            <span className="divider" />
            <ListItemText secondary={state.model.patient.pasNumber} />
          </ListItem>
        </List>
      </div>
    );
  };

  const contactDetailsRender = () => {
    return (
      <div className="clinician-info-box">
        <Typography variant="h6" gutterBottom>
          Contact Details
        </Typography>
        <List className="list-underline">
          <ListItem>
            <ListItemText primary="Address" />
            <span className="divider" />
            <ListItemText secondary={state.model.patient.address.fullAddress || '-'} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Landline Phone Number" />
            <span className="divider" />
            <ListItemText secondary={state.model.patient.contact.homeTelephoneDisplay || '-'} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Mobile Phone Number" />
            <span className="divider" />
            <ListItemText secondary={state.model.patient.contact.mobileTelephoneDisplay || '-'} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Other Phone Number" />
            <span className="divider" />
            <ListItemText secondary={state.model.patient.contact.workTelephoneDisplay || '-'} />
          </ListItem>
        </List>
      </div>
    );
  };

  const patientAddressRender = () => {
    return (
      <div className="clinician-info-box">
        <Typography variant="h6" gutterBottom>
          Address
        </Typography>
        <List className="list-underline">
          <ListItem>
            <ListItemText primary="Address line 1" />
            <span className="divider" />
            <ListItemText secondary={state.model.patient.address.addressLine1 || '-'} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Address line 2" />
            <span className="divider" />
            <ListItemText secondary={state.model.patient.address.addressLine2 || '-'} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Address line 3" />
            <span className="divider" />
            <ListItemText secondary={state.model.patient.address.addressLine3 || '-'} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Town City" />
            <span className="divider" />
            <ListItemText secondary={state.model.patient.address.townCity || '-'} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Post Code" />
            <span className="divider" />
            <ListItemText secondary={state.model.patient.address.postCode || '-'} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Access Details" />
            <span className="divider" />
            <ListItemText
              secondary={
                isExcludePropValue(state.model.patient.address.accessDetails)
                  ? state.model.patient.address.accessDetails || '-'
                  : '-'
              }
            />
          </ListItem>
        </List>
      </div>
    );
  };

  return (
    <section className="side-panel-content-wrapper">
      <SwipeableDrawer anchor="right" open onOpen={() => {}} onClose={onClose}>
        <div className="sidePanel-wrapper" style={{ width: '635px' }}>
          {state.model !== null && (
            <React.Fragment>
              {headerRender()}
              <div className="sidePanel-content">
                {patientAddressRender()}
                {contactDetailsRender()}
                {otherPatientDetailsRender()}
              </div>
            </React.Fragment>
          )}
        </div>
      </SwipeableDrawer>
    </section>
  );
}
